/*global angular */

(function (angular) {
'use strict';

var constants = angular.module('readly.constants', []);

constants.constant('DEBUG', false);
constants.constant('startSymbol', '{[{');
constants.constant('endSymbol', '}]}');
constants.constant('STATIC_URL', '/public/static/');
constants.constant('MEDIA_URL', '/public/media/');
constants.constant('DEFAULT_IMAGE_EXTENSION', 'jpg');
constants.constant('models', {
    book: {
        book: {
            dummyImage: '/public/static/images/new/default_cover.jpg',
            sizes: [
                [100, 0],
                [160, 0],
                [200, 0]
            ]
        },
        author: {
            dummyImage: '/public/static/images/new/author.jpg',
            sizes: [
                [100, 0],
                [180, 0]
            ]
        }
    },
    cauth: {
        user: {
            dummyImage: '/public/static/images/new/default_avatar.jpg',
            sizes: [
                [40, 40],
                [80, 80],
                [120, 120]
            ]
        }
    }
});

constants.constant('systemShelfNames', ['Добавить книгу', 'Хочу прочитать', 'Читаю', 'Прочитал', 'Избранное']);

}(angular));
